import { cloneElement, type FC, type ReactElement, type ReactNode, useState } from 'react';

import cn from 'classnames';

import { Accordion } from '@gds/Accordion/Accordion';

import styles from './FilterPanel.module.css';

interface SearchAccordionProps {
  className: string;
  title: string;
  open: boolean;
  disabled: boolean;
  dataTestId: string;
  children: ReactNode;
  onExpandedChange?: (expanded: boolean) => void;
  renderWhenClosed?: boolean;
}

const SearchAccordion: FC<SearchAccordionProps> = ({
  className,
  title,
  open,
  disabled,
  dataTestId,
  children,
  onExpandedChange,
  renderWhenClosed = true,
}) => {
  const [isSearchActive, setSearchIsActive] = useState(false);

  const triggerSearch = (searching: boolean) => setSearchIsActive(searching);

  const classes = cn({
    [className]: true,
    [styles.searching]: isSearchActive,
  });

  return (
    <Accordion
      className={classes}
      title={title}
      open={open}
      disabled={disabled}
      dataTestId={dataTestId}
      onExpandedChange={expanded => {
        !expanded && triggerSearch(false);
        onExpandedChange?.(expanded);
      }}
      renderWhenClosed={renderWhenClosed}
    >
      {cloneElement(children as ReactElement, {
        triggerSearch,
        searchIsActive: isSearchActive,
      })}
    </Accordion>
  );
};

export default SearchAccordion;
